import React from "react";
import { useTranslation } from "react-i18next";
import IconList from "../Components/IconList";
import rocket from "../../../Assets/icons/rocket.svg";
import coins from "../../../Assets/icons/coins.svg"
import gift from "../../../Assets/icons/gift.svg"

const CreditsRemovedConsent = () => {

    const { t } = useTranslation();

    return (
        <>
            <p>{t('consent.creditsRemoved.content')}</p>
            <IconList list={[
                {icon: rocket, text: t('consent.creditsRemoved.list.0')},
                {icon: coins, text: t('consent.creditsRemoved.list.1')},
                {icon: gift, text: t('consent.creditsRemoved.list.2')}
            ]} />
        </>
    );
}

export default CreditsRemovedConsent;